<template>
	<div>
		<div style="display: flex;align-items: center;justify-content: space-between;">
			<a-breadcrumb style="margin: 16px 0">
				<a-breadcrumb-item>主页</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectFirstMenu}}</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectSecondMenu}}</a-breadcrumb-item>
			</a-breadcrumb>
			<div>
				<a-button icon="sync" @click="apiOrdersQueryList">刷新</a-button>
			</div>
		</div>
		
		<a-collapse expandIconPosition="right" activeKey="1">
			<a-collapse-panel key="1" header="售票流水查询">
				<div class="qinang-search-row">
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">服务商：</div>
						<a-select v-model="query.facilitatorId" @change="facilitatorChange">
							<a-select-option :value="0">全部</a-select-option>
							<a-select-option v-for="(item, index) in facilitatorList" :key="index" :value="item.facilitatorId">{{item.facilitatorName}}</a-select-option>
						</a-select>
					</div>
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">售票点：</div>
						<a-select v-model="query.ticketstationId">
							<a-select-option :value="0">全部</a-select-option>
							<a-select-option v-for="(item, index) in ticketstationList" :key="index" :value="item.ticketstationId">{{item.ticketstationName}}</a-select-option>
						</a-select>
					</div>
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">售票员：</div>
						<a-select v-model="query.staffId">
							<a-select-option :value="0">全部</a-select-option>
							<a-select-option v-for="(item, index) in staffList" :key="index" :value="item.staffId">{{item.staffName}}</a-select-option>
						</a-select>
					</div>
				</div>
				<div class="qinang-margin-top-12 qinang-search-row">
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">查询日期：</div>
						<a-date-picker v-model="query.startTime" format="YYYY-MM-DD" class="qinang-search-time-picker-2" />
						<span style="width: 20px;text-align: center;">-</span>
						<a-date-picker class="qinang-search-time-picker-2" v-model="query.endTime" format="YYYY-MM-DD" />
					</div>
					
				</div>
				<div class="qinang-margin-top-12 qinang-search-row" style="justify-content: center;">
					<a-button type="primary" icon="search" @click="apiOrdersQueryList">查询</a-button>
					<a-button icon="redo" @click="apiOrdersQueryList" style="margin-left: 14px;">重置</a-button>
				</div>
			</a-collapse-panel>
		</a-collapse>
		
		<div class="qinang-card">
			<div style="width: 100%;text-align: center;margin: 20px;font-size: 16px;">景区售票员售票报表</div>
			<div style="margin: 20px 40px;">
				<table class="qa-table" style="width: 100%;border: 1px solid #000;">
					<tr style="background: #eee;">
						<th>姓名</th>
						<th>收款方式</th>
						<th>业务类型</th>
						<th>销售方式 </th>
						<th>票名</th>
						<th>人群</th>
						<th>单价</th>
						<th>数量</th>
						<th>金额</th>
					</tr>
				</table>
			</div>
			
		</div>


		
	</div>
</template>

<script>
	import moment from 'moment'
	export default {
		data() {
			return {
				moment,
				selectFirstMenu: window.sessionStorage.getItem('selectFirstMenu'),
				selectSecondMenu: window.sessionStorage.getItem('selectSecondMenu'),
				facilitatorList: [],//服务商列表
				ticketstationList: [],//售票站点列表
				staffList: [],//售票员列表
				// 搜索+表格-start
				query: {
					page: 1,
					size: 10,
					total: 0,
					facilitatorId: 0,
					ticketstationId: 0,
					ticketwindowId: 0,
					staffId: 0,
					startTime: moment().format('YYYY-MM-DD HH:mm:ss'),
					endTime: moment().format('YYYY-MM-DD HH:mm:ss'),
					ordersType: 0,
					ordersNumber: '',
				},
	
				tableData: [],
				tableColumns: [{
						title: '订单编号',
						dataIndex: 'ordersNumber',
						key: 'ordersNumber',
						align: 'center'
					},
					{
						title: '类型',
						key: 'ordersType',
						align: 'center',
						scopedSlots: {
							customRender: 'ordersType'
						}
					},
					{
						title: '服务商',
						dataIndex: 'facilitatorName',
						key: 'facilitatorName',
						align: 'center',
					},
					{
						title: '售票站点',
						dataIndex: 'ticketstationName',
						key: 'ticketstationName',
						align: 'center',
					},
					{
						title: '售票窗口',
						dataIndex: 'ticketwindowName',
						key: 'ticketwindowName',
						align: 'center',
					},
					{
						title: '售票员',
						dataIndex: 'staffName',
						key: 'staffName',
						align: 'center',
					},
					{
						title: '订单数量',
						dataIndex: 'ordersQuantity',
						key: 'ordersQuantity',
						align: 'center',
					},
					{
						title: '订单总价',
						key: 'ordersTotal',
						align: 'center',
						scopedSlots: {
							customRender: 'ordersTotal'
						}
					},
					{
						title: '下单时间',
						key: 'createTime',
						align: 'center',
						scopedSlots: {
							customRender: 'createTime'
						}
					},
					{
						title: '操作',
						key: 'tableAction',
						align: 'center',
						scopedSlots: {
							customRender: 'tableAction'
						}
					},

				],
				tableLoading: false,
				tableSelectedRows: {},
				//搜索+表格-end
		
			};
		},
		methods: {
			async apiFacilitatorListForStaff() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiFacilitatorListForStaff, {staffId:window.sessionStorage.getItem('staffId')});
				if (res.code == 200) {
					this.facilitatorList = res.data
				} else {

				}
			},
			facilitatorChange(e) {
				if(e == 0) {
					this.ticketstationList = []
				}else {
					this.apiTicketstationList()
				}
				this.query.ticketstationId = 0
			},
			async apiTicketstationList() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiTicketstationList, {facilitatorId:this.query.facilitatorId});
				if (res.code == 200) {
					this.ticketstationList = res.data
				} else {
			
				}
			},
			async apiStaffList() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiStaffList, {staffId:window.sessionStorage.getItem('staffId')});
				if (res.code == 200) {
					this.staffList = res.data
				} else {
			
				}
			},
			async apiOrdersQueryList() {
				let queryData = JSON.parse(JSON.stringify(this.query))
				queryData.startTime = this.moment(queryData.startTime).format('YYYY-MM-DD')
				queryData.endTime = this.moment(queryData.endTime).format('YYYY-MM-DD')
				this.tableLoading = true
				const {
					data: res
				} = await this.$http.post(this.navigation.apiOrdersQueryList, queryData);
				if (res.code == 200) {
					this.tableData = res.data.list
					this.query.page = res.data.pages.page
					this.query.size = res.data.pages.size
					this.query.total = res.data.pages.total
					// this.$message.success(res.msg)
					this.tableLoading = false
				} else {
					this.$message.error(res.msg)
					this.tableLoading = false
				}
			},
			pageChange(page, pageSize){
				this.query.page = page
				this.query.size = pageSize
				this.apiOrdersQueryList()
			},
			showSizeChange(current, size){
				this.query.page = current
				this.query.size = size
				this.apiOrdersQueryList()
			},

			
			tableSee() {
				if(this.tableSelectedRows.dutyId > 0) {
					// this.edit(this.tableSelectedRows)
				}else{
					this.$message.warning('请选择要修改的数据');
				}
			},
			OrderDetails(e) {
				console.log(e)
				window.sessionStorage.setItem('selectSecondMenu', '订单详情')
				window.sessionStorage.setItem('ticktingFlowsSelectOrder', JSON.stringify(e))
				this.$router.push('/OrderDetails')
			},
			
		},
		computed: {
			
		},
		created() {
			this.apiFacilitatorListForStaff()
			this.apiStaffList()
			this.apiOrdersQueryList()
		}
	};
</script>

<style scoped>
	.qa-table th{
		text-align: center;
		border: 1px solid #000;
	}

</style>
